import { isPastInPacific } from "helpers/pacificTime";

// Client rule (Aug 2026): a job whose start time has passed while still OPEN (nobody
// assigned) is Could Not Cover. Show that immediately — even one minute past — while the
// `appointments:mark-cnc` command persists status='cnc' in the database every 30 minutes.
//
// Judged in COURT (Pacific) time, not the viewer's: `appointments.datetime` is a Pacific
// wall-clock value and the backend gates visibility with PHP now() under
// APP_TIMEZONE=America/Los_Angeles. Comparing against the browser clock made this label
// contradict the API for anyone outside Pacific (a job 12 h in the future read as CNC).
//
// Display-only on purpose: the real `status` column drives SQL filters, the interpreter
// visibility rule and the King County payload, so it must never be shadowed.
export const effectiveStatus = (appointment) => {
  if (!appointment) return "";
  if (appointment.status === "open" && isPastInPacific(appointment.datetime)) {
    return "cnc";
  }
  return appointment.status;
};
